import * as React from "react";
import { ChevronDown, Tag } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ContractFamilyRole } from "@/types/contract-family";

import { ContractFamilyDocumentViewModel, formatContractFamilyRole } from "../contractFamilyViewModels";

interface Props {
  document: ContractFamilyDocumentViewModel;
  pending: boolean;
  onChangeRole: (role: ContractFamilyRole) => void;
}

const roles: ContractFamilyRole[] = ["MASTER", "CHILD", "AMENDMENT", "ANCILLARY", "NON_RELEVANT"];

export const ContractFamilyRoleMenu: React.FC<Props> = ({ document, pending, onChangeRole }) => (
  <DropdownMenu modal={false}>
    <DropdownMenuTrigger asChild>
      <Button type="button" size="xs" variant="outline" disabled={pending}>
        <Tag className="mr-1 h-3.5 w-3.5" />
        Role
        <ChevronDown className="ml-1 h-3.5 w-3.5" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="w-40">
      {roles.map(role => (
        <DropdownMenuItem
          key={role}
          className="cursor-pointer"
          disabled={role === document.role}
          onSelect={() => onChangeRole(role)}
        >
          {formatContractFamilyRole(role)}
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);
